var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("@/assets/images/404.png"),"alt":""}}),_vm._v(" nihao ")]),_c('div',{staticClass:"tip"},[_c('p',[_vm._v("页面哦豁了(っ °Д °;)っ")]),_c('p',[_vm._v("请联系管理员")])])])
}]

export { render, staticRenderFns }